//import {EventEmitter, ListenerFn} from 'eventemitter3';

import {ArgValidator} from './ArgValidator';

const EventEmitter = require('eventemitter3');

export type EventListenerFunction = (...args: Array<any>) => void;

/**
 * @interface IEventSubscriber - subscriber for event emitter
 */
export interface IEventEmitter {
    // /**
    //  * Add a listener for a given event.
    //  */
    // on(event: string, fn: EventListenerFunction, context?: any): any;
    // addListener(event: string, fn: EventListenerFunction, context?: any): any;
    //
    // /**
    //  * Add a one-time listener for a given event.
    //  */
    // once(event: string, fn: EventListenerFunction, context?: any): any;
    //
    // /**
    //  * Remove the listeners of a given event.
    //  */
    // removeListener(event: string, fn?: EventListenerFunction, context?: any, once?: boolean): any;
    // off(event: string, fn?: EventListenerFunction, context?: any, once?: boolean): any;
    //
    // /**
    //  * Remove all listeners, or those of the specified event.
    //  */
    // removeAllListeners(event?: string): any;



    /**
     * Calls each of the listeners registered for a given event.
     */
    emit(event: string | symbol, ...args: Array<any>): boolean;

    /**
     * Add a listener for a given event.
     */
    on(event: string | symbol, fn: EventListenerFunction, context?: any): any;


    /**
     * Remove the listeners of a given event.
     */
    removeListener(event: string | symbol, fn?: EventListenerFunction, context?: any, once?: boolean): any;

    /**
     * Remove all listeners, or those of the specified event.
     */
    removeAllListeners(event?: string | symbol): any;
}

/*export class EventEmitterEx extends EventEmitter implements IEventEmitter {
}*/

export function createEventEmmiter(): IEventEmitter {
    const ee = new EventEmitter() as any;
    return ee as IEventEmitter;
}


/** WEBPACK FOOTER **
 ** ./Engine/Utils/EventEmitterBase.ts
 **/